import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
  TextInput,
  Button,
  Spinner,
} from "flowbite-react";
import { ArrowRight, ArrowLeft ,CheckCircle, ShieldX ,PlusCircle,MinusCircle} from "lucide-react";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { generateBL } from "./GenerateBL";
import { FileDown } from "lucide-react";
const TransactionsPage = () => {
  const [user,setUser] = useState(null)
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalSims, setTotalSims] = useState(0);
  const [limit] = useState(10);
  const navigate = useNavigate();

  console.log(user)
const fetchUser = async () => {
  try {
 const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}auth/check/`,
        { withCredentials: true }
      );
      setUser(response.data.user)
  }
  catch(error) {
    console.log(error)
  }
  
}

  const fetchTransactions = async (page = 1, search = "") => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}relatedTransactions/?page=${page}&limit=${limit}&search=${search}`,
        { withCredentials: true }
      );
      setTransactions(response.data.data);
      setTotalPages(response.data.totalPages);
      setCurrentPage(response.data.currentPage);
      setTotalSims(response.data.total);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

   const acceptRejectTransaction = async (transactionId, status) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}terminateTransaction`,
          {
            transactionId,
            status,
          },
          { withCredentials: true }
        );
  
        if (response.status === 201) {
          fetchTransactions();
        }
      } catch (error) {
        console.error("Error accepting/rejecting transaction:", error);
      }
    };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

const formatICCID = (element) => {
  if(!element) {
    return 'N/A'
  }
return `${element.slice(0,3)}...${element.slice(12)}`

}

  useEffect(() => {
    fetchUser();
    const delayDebounceFn = setTimeout(() => {
      fetchTransactions(currentPage, searchTerm);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, currentPage, navigate]);

  return (
    <section className=" dark:bg-gray-900 w-full flex flex-col gap-3 mt-4">
      <div className="grid w-full grid-cols-1">
        <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800 mb-2">
          <div className="w-full sm:w-1/2 p-2">
            <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
              Mes Transactions
            </span>
          </div>
          <div className="w-full sm:w-1/2 p-2">
            <TextInput
              type="text"
              placeholder="Rechercher..."
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      <div className="overflow-x-auto rounded-md">
        <Table striped>
          <TableHead>
            <TableHeadCell>Type</TableHeadCell>
            <TableHeadCell>Status</TableHeadCell>
            <TableHeadCell>Expéditeur</TableHeadCell>
            <TableHeadCell>Destinataire</TableHeadCell>
            <TableHeadCell>Premier ICCID</TableHeadCell>
            <TableHeadCell>Dernier ICCID</TableHeadCell>
            <TableHeadCell>Quantité</TableHeadCell>
            <TableHeadCell>Batch</TableHeadCell>
            <TableHeadCell>Date</TableHeadCell>
           {user?.role !== "ADMIN" &&<TableHeadCell>Actions</TableHeadCell>}
            {["ADMIN","COMMERCIAL"].includes(user?.role) && <TableHeadCell>BL</TableHeadCell>}
          </TableHead>

          <TableBody className="divide-y">
            {transactions?.length ? (
              transactions?.map((transaction) => (
                <TableRow
                  key={transaction._id}
                  className="bg-white dark:border-gray-700 dark:bg-gray-800 text-xs
                  font-bold "
                >
                  <TableCell className={`flex flex-row items-center gap-1  ${
                      transaction.type === "affectation"
                        ? "text-green-500"
                        : transaction.type === "recouvrement"
                        ? "text-red-500"
                        : "text-gray-500"
                    } mt-2`}>
                      { transaction.type === "affectation" ? <PlusCircle size={16}/> : <MinusCircle size={16}/>}
                     <span>{transaction?.type?.toUpperCase()}</span> 
                      </TableCell>
                  <TableCell
                    className={`font-bold ${
                      transaction.status === "en attente"
                        ? "text-yellow-500"
                        : transaction.status === "accepté"
                        ? "text-green-500"
                        : transaction.status === "rejeté"
                        ? "text-red-500"
                        : "text-gray-500"
                    }`}
                  >
                    {transaction?.status?.toUpperCase()}
                  </TableCell>
                  <TableCell>{transaction.sender?.username}</TableCell>
                  <TableCell>{transaction.receiver?.username}</TableCell>
                  <TableCell className="cursor-pointer" title={transaction.first_iccid}>{formatICCID(transaction.first_iccid)}</TableCell>
                  <TableCell className="cursor-pointer" title={transaction.last_iccid}>{formatICCID(transaction.last_iccid)}</TableCell>
                  <TableCell>{transaction.quantity}</TableCell>
                  <TableCell>{transaction.batch_id?.batch_name}</TableCell>
                  <TableCell>
                    {new Date(transaction.createdAt).toLocaleDateString()}
                  </TableCell>
                 {user?.role !== "ADMIN" && user?._id === transaction?.receiver?._id?<TableCell>
                    <div className="flex gap-1">
                      <Button
                        pill
                        size="xs"
                        color={"dark"}
                        title="Accepter"
                        onClick={() =>
                          acceptRejectTransaction(transaction._id, "accepté")
                        }
                        disabled={transaction.status !== "en attente"}>
                        <CheckCircle size={14} className="text-green-500" />
                      </Button>
             
                     {/* {transaction.type !== "recouvrement" &&<Button
                        pill
                        size="xs"
                        color={"dark"}
                        title="Rejeter"
                        onClick={() =>
                          acceptRejectTransaction(transaction._id, "rejeté")
                        }
                        disabled={transaction.status !== "en attente"}>
                        <ShieldX size={14} className="text-red-400" />
                      </Button>} */}
                    </div>
                  </TableCell>:
                  <TableCell>
                    <div className="flex gap-1">
                      <Button
                        pill
                        size="xs"
                        color={"dark"}
                        title="Accepter"
                        disabled={true}>
                        {/* <CheckCircle size={14} className="text-green-500" /> */}
                      </Button>
             
                    </div>
                  </TableCell>}
                  <TableCell>
                    {["ADMIN", "COMMERCIAL"].includes(user?.role) && transaction?.sender?.username === user?.username && (
                      <Button
                        pill
                        size="xs"
                        color="dark"
                        title="Télécharger BL"
                        onClick={() => generateBL(transaction)}
                      >
                        <FileDown size={14} className="text-blue-400" />
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow className="bg-white dark:border-gray-700 dark:bg-gray-800 cursor-pointer hover:bg-slate-300">
                <TableCell>
                  {" "}
                  {loading ? <Spinner /> : "Aucune transaction trouvée ."}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      <section className="md:px-4 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-md w-full p-2 flex flex-row justify-between">
        <div className="flex justify-center items-center gap-2">
          <Button
            disabled={currentPage === 1 || totalPages === 0}
            onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
            color={"dark"}
            size="xs"
          >
            <ArrowLeft size={16} />
          </Button>
          <span className="self-center">
            Page {currentPage} / {totalPages}
          </span>
          <Button
            disabled={currentPage === totalPages || totalPages === 0}
            onClick={() =>
              setCurrentPage((prev) => Math.min(totalPages, prev + 1))
            }
            color={"dark"}
            size="xs"
          >
            <ArrowRight size={16} />
          </Button>
        </div>
        <div>
          <span>Total : {totalSims}</span>
        </div>
      </section>
    </section>
  );
};

export default TransactionsPage;
